<template>
  <div
    class="sb-group-button"
    :class="hasSpaces && 'sb-group-button--has-spaces'"
    v-bind="$attrs"
    role="group"
  >
    <VNodes :vnodes="activeSlots()" />
  </div>
</template>

<script setup lang="ts">
import VNodes from '../../utils/VNodes'
import type { VNode } from 'vue'
import type {
  SharedButtonAppearance,
  SharedButtonSize,
  SharedButtonType,
  SharedButtonVariant,
} from '../shared/button/types'

export type GroupButtonProps = {
  appearance?: SharedButtonAppearance
  variant?: SharedButtonVariant
  size?: SharedButtonSize
  type?: SharedButtonType
  hasSpaces?: boolean
}

const props = defineProps<GroupButtonProps>()

const slots = defineSlots<{
  default(): VNode[]
}>()

const activeSlots = () => {
  const children = slots.default ? slots.default() : []
  return children
    .filter((b) => 'type' in b)
    .map((button) => {
      button.props = {
        ...button.props,
        variant: props.variant,
        size: props.size,
        type: props.type,
        appearance: props.appearance,
      }
      return button
    })
}
</script>
